import pageText from '../content/PluginAddendum.md?raw';
import LegalPageLayout from './LegalPageLayout';

export default function PluginAddendumPage() {
  return <LegalPageLayout content={pageText} />;
}
